import ModalManagement from "generalComponents/CustomModal";
import React from "react";
import { format } from "date-fns";
import Loader from "generalComponents/Loader";
// import { RoundedButton } from "generalComponents/Button";

const SingleEventModal = ({ id, onClose, event }) => {
  return (
    <ModalManagement id={id} title={"Event Details"} onClose={onClose}>
      {event?.id ? (
        <div className="px-12">
          <img
            src={event?.cover_image?.url}
            className="rounded-[10px] mb-5"
            alt=""
          />

          <p className="text-xl font-semibold text-purpleOverlay mb-5">
            {event?.name}
          </p>
          <div className="flex items-center gap-2 mb-5">
            <svg
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.58301 9.50033C1.58301 6.51476 1.58301 5.02199 2.5105 4.09448C3.438 3.16699 4.93078 3.16699 7.91634 3.16699H11.083C14.0685 3.16699 15.5614 3.16699 16.4888 4.09448C17.4163 5.02199 17.4163 6.51476 17.4163 9.50033V11.0837C17.4163 14.0692 17.4163 15.562 16.4888 16.4895C15.5614 17.417 14.0685 17.417 11.083 17.417H7.91634C4.93078 17.417 3.438 17.417 2.5105 16.4895C1.58301 15.562 1.58301 14.0692 1.58301 11.0837V9.50033Z"
                stroke="#8311B3"
                strokeWidth="1.1875"
              />
              <path
                opacity="0.5"
                d="M5.54199 3.16699V1.97949"
                stroke="#8311B3"
                strokeWidth="1.1875"
                strokeLinecap="round"
              />
              <path
                opacity="0.5"
                d="M13.458 3.16699V1.97949"
                stroke="#8311B3"
                strokeWidth="1.1875"
                strokeLinecap="round"
              />
              <path
                opacity="0.5"
                d="M1.97949 7.125H17.0212"
                stroke="#8311B3"
                strokeWidth="1.1875"
                strokeLinecap="round"
              />
              <path
                d="M14.2503 13.4587C14.2503 13.8959 13.8959 14.2503 13.4587 14.2503C13.0214 14.2503 12.667 13.8959 12.667 13.4587C12.667 13.0214 13.0214 12.667 13.4587 12.667C13.8959 12.667 14.2503 13.0214 14.2503 13.4587Z"
                fill="#8311B3"
              />
              <path
                d="M14.2503 10.2917C14.2503 10.7289 13.8959 11.0833 13.4587 11.0833C13.0214 11.0833 12.667 10.7289 12.667 10.2917C12.667 9.85443 13.0214 9.5 13.4587 9.5C13.8959 9.5 14.2503 9.85443 14.2503 10.2917Z"
                fill="#8311B3"
              />
              <path
                d="M10.2913 13.4587C10.2913 13.8959 9.93691 14.2503 9.49967 14.2503C9.06244 14.2503 8.70801 13.8959 8.70801 13.4587C8.70801 13.0214 9.06244 12.667 9.49967 12.667C9.93691 12.667 10.2913 13.0214 10.2913 13.4587Z"
                fill="#8311B3"
              />
              <path
                d="M10.2913 10.2917C10.2913 10.7289 9.93691 11.0833 9.49967 11.0833C9.06244 11.0833 8.70801 10.7289 8.70801 10.2917C8.70801 9.85443 9.06244 9.5 9.49967 9.5C9.93691 9.5 10.2913 9.85443 10.2913 10.2917Z"
                fill="#8311B3"
              />
              <path
                d="M6.33333 13.4587C6.33333 13.8959 5.97889 14.2503 5.54167 14.2503C5.10445 14.2503 4.75 13.8959 4.75 13.4587C4.75 13.0214 5.10445 12.667 5.54167 12.667C5.97889 12.667 6.33333 13.0214 6.33333 13.4587Z"
                fill="#8311B3"
              />
              <path
                d="M6.33333 10.2917C6.33333 10.7289 5.97889 11.0833 5.54167 11.0833C5.10445 11.0833 4.75 10.7289 4.75 10.2917C4.75 9.85443 5.10445 9.5 5.54167 9.5C5.97889 9.5 6.33333 9.85443 6.33333 10.2917Z"
                fill="#8311B3"
              />
            </svg>
            <p className="font-medium text-xs text-[#828282]">
              {format(new Date(event?.date), "iii LLL d, uuuu")}
            </p>
          </div>
          <div className="flex items-center gap-2 mb-10">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_839_20752)">
                <path
                  d="M16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 7.82319 0.0702379 7.65362 0.195262 7.5286C0.320286 7.40357 0.489856 7.33333 0.666667 7.33333C0.843478 7.33333 1.01305 7.40357 1.13807 7.5286C1.2631 7.65362 1.33333 7.82319 1.33333 8C1.33333 9.31854 1.72433 10.6075 2.45687 11.7038C3.18941 12.8001 4.2306 13.6546 5.44878 14.1592C6.66695 14.6638 8.0074 14.7958 9.3006 14.5386C10.5938 14.2813 11.7817 13.6464 12.714 12.714C13.6464 11.7817 14.2813 10.5938 14.5386 9.3006C14.7958 8.0074 14.6638 6.66695 14.1592 5.44878C13.6546 4.2306 12.8001 3.18941 11.7038 2.45687C10.6075 1.72433 9.31854 1.33333 8 1.33333C7.82319 1.33333 7.65362 1.2631 7.5286 1.13807C7.40357 1.01305 7.33333 0.843478 7.33333 0.666667C7.33333 0.489856 7.40357 0.320286 7.5286 0.195262C7.65362 0.0702379 7.82319 0 8 0C10.121 0.00229405 12.1545 0.845885 13.6543 2.34568C15.1541 3.84547 15.9977 5.87897 16 8ZM6.85133 7.33333H5.33333C5.15652 7.33333 4.98695 7.40357 4.86193 7.5286C4.7369 7.65362 4.66667 7.82319 4.66667 8C4.66667 8.17681 4.7369 8.34638 4.86193 8.47141C4.98695 8.59643 5.15652 8.66667 5.33333 8.66667H6.85133C6.95314 8.84348 7.09429 8.99449 7.26384 9.108C7.43339 9.2215 7.62679 9.29445 7.82906 9.32121C8.03134 9.34795 8.23705 9.32778 8.43028 9.26226C8.6235 9.19673 8.79905 9.0876 8.94333 8.94333C9.0876 8.79905 9.19673 8.6235 9.26226 8.43028C9.32778 8.23705 9.34795 8.03134 9.32121 7.82906C9.29445 7.62679 9.2215 7.43339 9.108 7.26384C8.99449 7.09429 8.84348 6.95314 8.66667 6.85133V4.66667C8.66667 4.48986 8.59643 4.32029 8.47141 4.19526C8.34638 4.07024 8.17681 4 8 4C7.82319 4 7.65362 4.07024 7.5286 4.19526C7.40357 4.32029 7.33333 4.48986 7.33333 4.66667V6.85133C7.13362 6.96752 6.96752 7.13362 6.85133 7.33333ZM1.218 5.856C1.34985 5.856 1.47875 5.8169 1.58838 5.74365C1.69801 5.67039 1.78346 5.56627 1.83392 5.44446C1.88438 5.32264 1.89758 5.18859 1.87186 5.05927C1.84613 4.92995 1.78264 4.81116 1.6894 4.71793C1.59617 4.62469 1.47738 4.5612 1.34806 4.53548C1.21874 4.50975 1.0847 4.52296 0.962878 4.57341C0.84106 4.62387 0.736941 4.70932 0.663687 4.81895C0.590433 4.92859 0.551333 5.05748 0.551333 5.18933C0.551333 5.36614 0.621571 5.53571 0.746596 5.66074C0.87162 5.78576 1.04119 5.856 1.218 5.856ZM2.814 3.47133C2.94585 3.47133 3.07475 3.43223 3.18438 3.35898C3.29401 3.28573 3.37946 3.18161 3.42992 3.05979C3.48038 2.93797 3.49358 2.80393 3.46786 2.67461C3.44213 2.54529 3.37864 2.4265 3.2854 2.33326C3.19217 2.24003 3.07338 2.17653 2.94406 2.15081C2.81474 2.12509 2.6807 2.13829 2.55888 2.18875C2.43706 2.23921 2.33294 2.32465 2.25969 2.43429C2.18643 2.54392 2.14733 2.67281 2.14733 2.80467C2.14733 2.98148 2.21757 3.15105 2.3426 3.27607C2.46762 3.4011 2.63719 3.47133 2.814 3.47133ZM5.186 1.894C5.31785 1.894 5.44675 1.8549 5.55638 1.78165C5.66601 1.70839 5.75146 1.60427 5.80192 1.48246C5.85238 1.36064 5.86558 1.22659 5.83986 1.09727C5.81413 0.967952 5.75064 0.849164 5.6574 0.755929C5.56417 0.662694 5.44538 0.5992 5.31606 0.573476C5.18674 0.547753 5.0527 0.560955 4.93088 0.611414C4.80906 0.661872 4.70494 0.74732 4.63169 0.856953C4.55843 0.966586 4.51933 1.09548 4.51933 1.22733C4.51933 1.40414 4.58957 1.57371 4.7146 1.69874C4.83962 1.82376 5.00919 1.894 5.186 1.894Z"
                  fill="#8311B3"
                />
              </g>
              <defs>
                <clipPath id="clip0_839_20752">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <p className="font-medium text-xs text-[#828282]">{event?.time}</p>
          </div>

          <p className="text-xs text-[#828282] mb-10">{event?.description}</p>

          {/* <RoundedButton
            external
            className="w-full py-4 block text-center"
            disabled={new Date()?.getTime() > new Date(event?.date)?.getTime()}
            url="/"
          >
            + Add to Calendar
          </RoundedButton> */}
        </div>
      ) : (
        <Loader />
      )}
    </ModalManagement>
  );
};

export default SingleEventModal;
